<template>



	<el-form v-if="form" label-position="top">
		<el-form-item label="角色ID">
			<el-input v-model="form.id" :disabled="mode!='create'"></el-input>
		</el-form-item>


		<el-form-item label="角色名称">
			<el-input v-model="form.name"></el-input>
		</el-form-item>

		<el-form-item label="图片">
			<ImageUpload v-model="form.image"></ImageUpload>
		</el-form-item>

		<el-form-item label="角色提示词">
			<el-input v-model="form.prompt" type="textarea" :rows="10"></el-input>
		</el-form-item>


		<el-form-item label="最大tokens">
			<el-input v-model="form.maxTokens"></el-input>
		</el-form-item>


		<el-form-item label="最大历史">
			<el-input v-model="form.maxMemory"></el-input>
		</el-form-item>


		<el-form-item label="LLM">
			<el-select v-model="form.llm" placeholder="请选择">
				<el-option v-for="item in config.llms" :key="item.model" :label="item.model" :value="item.model">
				</el-option>
			</el-select>
		</el-form-item>

		<el-form-item label="ASR">
			<el-select v-model="form.asr" placeholder="请选择">
				<el-option v-for="item in ['gpt-4o-mini']" :key="item" :label="item" :value="item">
				</el-option>
			</el-select>
		</el-form-item>

		<el-form-item label="TTS">
			<el-select v-model="form.tts" placeholder="请选择">
				<el-option v-for="item in ['gpt-4o-mini']" :key="item" :label="item" :value="item">
				</el-option>
			</el-select>
		</el-form-item>


		<el-form-item>
			<el-button type="primary" @click="submit">save</el-button>
		</el-form-item>
	</el-form>
</template>

<script>
	import ImageUpload from '@/components/ImageUpload'
	import mixin from '@/utils/mixin';
	export default {
		mixins: [mixin],
		components: {
			ImageUpload,
		},
		data() {
			return {
				form: {},
			}
		},
		mounted() {
			this.form = {
				...this.propForm
			}
		},
		methods: {

			close() {
				this.$emit('close');
			},
			submit() {
				if (this.mode == 'create') {
					request({
						url: '/api/role/createRole',
						data: {
							...this.form,
						},
						success: resp => {
							Message.success();
							this.$emit('success')
						}
					})
				} else if (this.mode == 'update') {
					request({
						url: '/api/role/updateRole',
						data: {
							...this.form,
						},
						success: resp => {
							Message.success();
							this.$emit('success')
						}
					})
				}
			},


		}
	}
</script>

<style>

</style>